import { useMutation } from "@tanstack/react-query";

import { upsertIntegration } from "../api/integrations";

export const useUpsertIntegration = () => {
  return useMutation({
    mutationFn: upsertIntegration,
  });
};
